// extracted by mini-css-extract-plugin
export default {"wrap":"index-module_wrap_7sviE","empty":"index-module_empty_OK2Vz"};